// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card */
.card {
   margin-bottom: 30px;
   border: none;
   border-radius: 5px;
   box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
 }
 
 .card-header,
 .card-footer {
   border-color: #ebeef4;
   background-color: #fff;
   color: #798eb3;
   padding: 15px;
 }
 
 .user-webnexs .card-title {
   padding: 20px 0 15px 0;
   font-size: 18px;
   font-weight: 500;
   color: #000000;
   font-family: "Poppins", sans-serif;
 }
 
 .user-webnexs span.small.pt-1.fw-bold {
   color: black;
 }
 
 .card-title span {
   color: #899bbd;
   font-size: 14px;
   font-weight: 400;
 }
 
 .card-body {
   padding: 0 20px 20px 20px;
 }
 
 .card-img-overlay {
   background-color: rgba(255, 255, 255, 0.6);
 }
 
 .dashboard .nav-link {
   border-radius: 5px;
   border-bottom: 1px solid #e9e6e6;
   font-weight: 500;
   color: #000000;
   background-color: #e1e1e1;
 }
 
 .dashboard .nav-link.active {
   background: rgb(255 255 255 / 20%);
   font-size: 16px;
   font-weight: 500;
   color: #000;
 }
 
 .upload-video {
   background-color: #fafafa;
   padding: 10px;
   border-radius: 10px;
 }
 
 .iq-card {
   background: #fff;
   border-radius: 5px;
   margin-bottom: 30px;
   border: none;
   box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
   border-radius: 5px;
 }
 
 .react-calendar {
   width: 100% !important;
   max-width: 100%;
   background: white;
   border: 1px solid #a0a096;
   font-family: Arial, Helvetica, sans-serif;
   line-height: 1.125em;
 }
 .react-calendar--doubleView {
   width: 700px;
 }
 .react-calendar--doubleView .react-calendar__viewContainer {
   display: flex;
   margin: -0.5em;
 }
 .react-calendar--doubleView .react-calendar__viewContainer > * {
   width: 50%;
   margin: 0.5em;
 }
 .react-calendar,
 .react-calendar *,
 .react-calendar *:before,
 .react-calendar *:after {
   box-sizing: border-box;
 }
 .react-calendar button {
   margin: 0;
   border: 0;
   outline: none;
 }
 .react-calendar button:enabled:hover {
   cursor: pointer;
 }
 .react-calendar__navigation {
   display: flex;
   height: 44px;
   margin-bottom: 1em;
 }
 .react-calendar__navigation button {
   min-width: 44px;
   background: none;
 }
 .react-calendar__navigation button:disabled {
   background-color: #f0f0f0;
 }
 .react-calendar__navigation button:enabled:hover,
 .react-calendar__navigation button:enabled:focus {
   background-color: #e6e6e6;
 }
 .react-calendar__month-view__weekdays {
   text-align: center;
   text-transform: uppercase;
   font-weight: bold;
   font-size: 0.75em;
 }
 .react-calendar__month-view__weekdays__weekday {
   padding: 0.5em;
 }
 .react-calendar__month-view__weekNumbers .react-calendar__tile {
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 0.75em;
   font-weight: bold;
 }
 .react-calendar__month-view__days__day--weekend {
   color: #d10000;
 }
 .react-calendar__month-view__days__day--neighboringMonth {
   color: #757575;
 }
 .react-calendar__year-view .react-calendar__tile,
 .react-calendar__decade-view .react-calendar__tile,
 .react-calendar__century-view .react-calendar__tile {
   padding: 2em 0.5em;
 }
 .react-calendar__tile {
   max-width: 100%;
   padding: 20px 0.6667px;
   background: none;
   text-align: center;
   line-height: 16px;
 }
 .react-calendar__tile:disabled {
   background-color: #f0f0f0;
 }
 .react-calendar__tile:enabled:hover,
 .react-calendar__tile:enabled:focus {
   background-color: #e6e6e6;
 }
 .react-calendar__tile--now {
   background: #ffff76;
 }
 .react-calendar__tile--now:enabled:hover,
 .react-calendar__tile--now:enabled:focus {
   background: #ffffa9;
 }
 .react-calendar__tile--hasActive {
   background: #76baff;
 }
 .react-calendar__tile--hasActive:enabled:hover,
 .react-calendar__tile--hasActive:enabled:focus {
   background: #a9d4ff;
 }
 .react-calendar__tile--active {
   background: #006edc;
   color: white;
 }
 .react-calendar__tile--active:enabled:hover,
 .react-calendar__tile--active:enabled:focus {
   background: #1087ff;
 }
 .react-calendar--selectRange .react-calendar__tile--hover {
   background-color: #e6e6e6;
 }
 
 .fc-direction-ltr .fc-daygrid-event .fc-event-time {
   display: none;
 }
 
 .fc-daygrid-event-dot {
   display: none;
 }
 
 .centered-event-title {
   text-align: center;
 }
 `, "",{"version":3,"sources":["webpack://./src/AdvertiserPortal/Styles/ScheduleAdvertisement.css"],"names":[],"mappings":"AAAA,SAAS;AACT;GACG,mBAAmB;GACnB,YAAY;GACZ,kBAAkB;GAClB,4CAA4C;CAC9C;;CAEA;;GAEE,qBAAqB;GACrB,sBAAsB;GACtB,cAAc;GACd,aAAa;CACf;;CAEA;GACE,sBAAsB;GACtB,eAAe;GACf,gBAAgB;GAChB,cAAc;GACd,kCAAkC;CACpC;;CAEA;GACE,YAAY;CACd;;CAEA;GACE,cAAc;GACd,eAAe;GACf,gBAAgB;CAClB;;CAEA;GACE,yBAAyB;CAC3B;;CAEA;GACE,0CAA0C;CAC5C;;CAEA;GACE,kBAAkB;GAClB,gCAAgC;GAChC,gBAAgB;GAChB,cAAc;GACd,yBAAyB;CAC3B;;CAEA;GACE,kCAAkC;GAClC,eAAe;GACf,gBAAgB;GAChB,WAAW;CACb;;CAEA;GACE,yBAAyB;GACzB,aAAa;GACb,mBAAmB;CACrB;;CAEA;GACE,gBAAgB;GAGhB,kBAAkB;GAClB,mBAAmB;GACnB,YAAY;GACZ,wCAAwC;GACxC,kBAAkB;CACpB;;CAEA;GACE,sBAAsB;GACtB,eAAe;GACf,iBAAiB;GACjB,yBAAyB;GACzB,yCAAyC;GACzC,oBAAoB;CACtB;CACA;GACE,YAAY;CACd;CACA;GACE,aAAa;GACb,cAAc;CAChB;CACA;GACE,UAAU;GACV,aAAa;CACf;CACA;;;;GAME,sBAAsB;CACxB;CACA;GACE,SAAS;GACT,SAAS;GACT,aAAa;CACf;CACA;GACE,eAAe;CACjB;CACA;GACE,aAAa;GACb,YAAY;GACZ,kBAAkB;CACpB;CACA;GACE,eAAe;GACf,gBAAgB;CAClB;CACA;GACE,yBAAyB;CAC3B;CACA;;GAEE,yBAAyB;CAC3B;CACA;GACE,kBAAkB;GAClB,yBAAyB;GACzB,iBAAiB;GACjB,iBAAiB;CACnB;CACA;GACE,cAAc;CAChB;CACA;GACE,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,iBAAiB;GACjB,iBAAiB;CACnB;CACA;GACE,cAAc;CAChB;CACA;GACE,cAAc;CAChB;CACA;;;GAGE,kBAAkB;CACpB;CACA;GACE,eAAe;GACf,sBAAsB;GACtB,gBAAgB;GAChB,kBAAkB;GAClB,iBAAiB;CACnB;CACA;GACE,yBAAyB;CAC3B;CACA;;GAEE,yBAAyB;CAC3B;CACA;GACE,mBAAmB;CACrB;CACA;;GAEE,mBAAmB;CACrB;CACA;GACE,mBAAmB;CACrB;CACA;;GAEE,mBAAmB;CACrB;CACA;GACE,mBAAmB;GACnB,YAAY;CACd;CACA;;GAEE,mBAAmB;CACrB;CACA;GACE,yBAAyB;CAC3B;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,kBAAkB;CACpB","sourcesContent":["/* Card */\n.card {\n   margin-bottom: 30px;\n   border: none;\n   border-radius: 5px;\n   box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n }\n \n .card-header,\n .card-footer {\n   border-color: #ebeef4;\n   background-color: #fff;\n   color: #798eb3;\n   padding: 15px;\n }\n \n .user-webnexs .card-title {\n   padding: 20px 0 15px 0;\n   font-size: 18px;\n   font-weight: 500;\n   color: #000000;\n   font-family: \"Poppins\", sans-serif;\n }\n \n .user-webnexs span.small.pt-1.fw-bold {\n   color: black;\n }\n \n .card-title span {\n   color: #899bbd;\n   font-size: 14px;\n   font-weight: 400;\n }\n \n .card-body {\n   padding: 0 20px 20px 20px;\n }\n \n .card-img-overlay {\n   background-color: rgba(255, 255, 255, 0.6);\n }\n \n .dashboard .nav-link {\n   border-radius: 5px;\n   border-bottom: 1px solid #e9e6e6;\n   font-weight: 500;\n   color: #000000;\n   background-color: #e1e1e1;\n }\n \n .dashboard .nav-link.active {\n   background: rgb(255 255 255 / 20%);\n   font-size: 16px;\n   font-weight: 500;\n   color: #000;\n }\n \n .upload-video {\n   background-color: #fafafa;\n   padding: 10px;\n   border-radius: 10px;\n }\n \n .iq-card {\n   background: #fff;\n   -webkit-border-radius: 5px;\n   -moz-border-radius: 5px;\n   border-radius: 5px;\n   margin-bottom: 30px;\n   border: none;\n   box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\n   border-radius: 5px;\n }\n \n .react-calendar {\n   width: 100% !important;\n   max-width: 100%;\n   background: white;\n   border: 1px solid #a0a096;\n   font-family: Arial, Helvetica, sans-serif;\n   line-height: 1.125em;\n }\n .react-calendar--doubleView {\n   width: 700px;\n }\n .react-calendar--doubleView .react-calendar__viewContainer {\n   display: flex;\n   margin: -0.5em;\n }\n .react-calendar--doubleView .react-calendar__viewContainer > * {\n   width: 50%;\n   margin: 0.5em;\n }\n .react-calendar,\n .react-calendar *,\n .react-calendar *:before,\n .react-calendar *:after {\n   -moz-box-sizing: border-box;\n   -webkit-box-sizing: border-box;\n   box-sizing: border-box;\n }\n .react-calendar button {\n   margin: 0;\n   border: 0;\n   outline: none;\n }\n .react-calendar button:enabled:hover {\n   cursor: pointer;\n }\n .react-calendar__navigation {\n   display: flex;\n   height: 44px;\n   margin-bottom: 1em;\n }\n .react-calendar__navigation button {\n   min-width: 44px;\n   background: none;\n }\n .react-calendar__navigation button:disabled {\n   background-color: #f0f0f0;\n }\n .react-calendar__navigation button:enabled:hover,\n .react-calendar__navigation button:enabled:focus {\n   background-color: #e6e6e6;\n }\n .react-calendar__month-view__weekdays {\n   text-align: center;\n   text-transform: uppercase;\n   font-weight: bold;\n   font-size: 0.75em;\n }\n .react-calendar__month-view__weekdays__weekday {\n   padding: 0.5em;\n }\n .react-calendar__month-view__weekNumbers .react-calendar__tile {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   font-size: 0.75em;\n   font-weight: bold;\n }\n .react-calendar__month-view__days__day--weekend {\n   color: #d10000;\n }\n .react-calendar__month-view__days__day--neighboringMonth {\n   color: #757575;\n }\n .react-calendar__year-view .react-calendar__tile,\n .react-calendar__decade-view .react-calendar__tile,\n .react-calendar__century-view .react-calendar__tile {\n   padding: 2em 0.5em;\n }\n .react-calendar__tile {\n   max-width: 100%;\n   padding: 20px 0.6667px;\n   background: none;\n   text-align: center;\n   line-height: 16px;\n }\n .react-calendar__tile:disabled {\n   background-color: #f0f0f0;\n }\n .react-calendar__tile:enabled:hover,\n .react-calendar__tile:enabled:focus {\n   background-color: #e6e6e6;\n }\n .react-calendar__tile--now {\n   background: #ffff76;\n }\n .react-calendar__tile--now:enabled:hover,\n .react-calendar__tile--now:enabled:focus {\n   background: #ffffa9;\n }\n .react-calendar__tile--hasActive {\n   background: #76baff;\n }\n .react-calendar__tile--hasActive:enabled:hover,\n .react-calendar__tile--hasActive:enabled:focus {\n   background: #a9d4ff;\n }\n .react-calendar__tile--active {\n   background: #006edc;\n   color: white;\n }\n .react-calendar__tile--active:enabled:hover,\n .react-calendar__tile--active:enabled:focus {\n   background: #1087ff;\n }\n .react-calendar--selectRange .react-calendar__tile--hover {\n   background-color: #e6e6e6;\n }\n \n .fc-direction-ltr .fc-daygrid-event .fc-event-time {\n   display: none;\n }\n \n .fc-daygrid-event-dot {\n   display: none;\n }\n \n .centered-event-title {\n   text-align: center;\n }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
